import { useEffect, useMemo, useRef, useState } from 'react'
import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import {
  IStringInputSettings,
  KeyTypes,
  StringVariants,
} from '../inputs.interface'
import {
  DATE_MASK,
  DATE_PARTS_COUNT,
  GLUED_DATE_STRING_REGEX,
  NUMBERS_AND_MASK_SYMBOLS_REGEX,
  ONLY_NUMBERS_REGEX,
  SEPARATOR_POSITIONS,
  UNDERDASH,
} from './utils/config'
import createMaskedDate from './utils/createMaskedDate'
import { getTrueCursorPosition } from './utils/cursor'
import useLocalStatus from '../../../module/hooks/useLocalStatus/useLocalStatus'

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: IStringInputSettings
  progressTrigger?: Function
  checkChangeValue: Function
}
export const useDate = ({
  value,
  name,
  handleChange,
  status,
  settings,
  progressTrigger,
  checkChangeValue
}: Props) => {
  const { isValidate, placeholder } = settings
  const [localValue, setLocalValue] = useState<string>(
    value && value.length ? value.split('-').reverse().join('.') : value
  )
  const [focused, setFocused] = useState<boolean>(false)
  // const [localStatus, setLocalStatus] = useState<IInputStatus>(IInputStatus.none)
  const [isDelete, setIsDelete] = useState<boolean>(false)
  const [keyType, setKeyType] = useState<KeyTypes>(KeyTypes.default)
  const [cursorPosition, setCursorPosition] = useState<number>(0)
  const [localPlaceholder, setLocalPlaceholder] = useState<string>(
    placeholder ?? DATE_MASK
  )

  const inputRef = useRef<HTMLInputElement>(null)

  const {
    localStatus,
    changeStatusHandler,
    setChangeStatusHandler
  } = useLocalStatus({
    value,
    status,
    focused,
    progressTrigger
  })

  // const {
  //   localValue,
  //   localStatus,
  //   handleLocalChange,
  //   handleKeydown,
  //   handleBlur,
  //   focused,
  //   setFocused
  // } = useChangeDataHook({
  //   value,
  //   name,
  //   handleChange,
  //   inputRef,
  //   status,
  //   checkChangeValue,
  //   progressTrigger
  // })

  // useEffect(() => {
    
  //   if (
  //     !focused &&
  //     (status === IInputStatus.apiError
  //     || status === IInputStatus.error)
  //   ) {
  //     setLocalStatus(status)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   } else if ( status === IInputStatus.success && !focused) {
  //     setLocalStatus(IInputStatus.success)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   } else {
  //     // setLocalStatus(status)
  //   }
  // }, [status])

  // useEffect(() => {
  //   try {
  //     if (localValue) {
  //       const transformedValue = localValue
  //         .split('.')
  //         .map((datePart: string) =>
  //           datePart
  //             .split('')
  //             .filter((symbol) => symbol.match(/\d/))
  //             .join('')
  //         )
  //         .reverse()
  //         .join('-')
  //       handleChange(name, transformedValue, isValidate)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }, [localValue])

  useEffect(() => {
    try {
      // Устанавить placeholder в зависимости от фокуса
      if (focused) {
        setLocalPlaceholder(placeholder ?? DATE_MASK)
      } else {
        setLocalPlaceholder('')
      }
    } catch (error) {
      console.log(error)
    }
  }, [focused])

  useEffect(() => {
    try {
      // Переместить курсор при вводе значения или удалении
      if (localValue) {
        const firstDashIndex = localValue.indexOf(UNDERDASH)
        if (inputRef.current) {
          switch (keyType) {
            case KeyTypes.backspace:
              if (SEPARATOR_POSITIONS.includes(cursorPosition)) {
                inputRef.current.selectionEnd = cursorPosition - 2
              } else {
                inputRef.current.selectionEnd = cursorPosition - 1
              }
              break
            case KeyTypes.delete:
              inputRef.current.selectionEnd = cursorPosition
              break
            default:
              if (SEPARATOR_POSITIONS.includes(cursorPosition)) {
                inputRef.current.selectionEnd = cursorPosition + 1
              } else {
                inputRef.current.selectionEnd = cursorPosition
              }
              break
          }
          /*
            if (true) {
              if (SEPARATOR_POSITIONS.includes(cursorPosition)) {
                inputRef.current.selectionEnd = cursorPosition - 2
              } else {
                inputRef.current.selectionEnd = cursorPosition - 1
              }
            } else {
              if (SEPARATOR_POSITIONS.includes(cursorPosition)) {
                inputRef.current.selectionEnd = cursorPosition + 1
              } else {
                inputRef.current.selectionEnd = cursorPosition
              }
            }
    */
          // При удалении переместить курсор за разделитель
          if (
            keyType === KeyTypes.backspace &&
            SEPARATOR_POSITIONS.includes(cursorPosition)
          ) {
            //inputRef.current.selectionEnd = cursorPosition - 2
          } else if (keyType === KeyTypes.backspace) {
            //inputRef.current.selectionEnd = firstDashIndex
          } else if (firstDashIndex !== -1) {
            //inputRef.current.selectionEnd = firstDashIndex
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }, [localValue, cursorPosition, isDelete, keyType])

  const localSettings = useMemo(
    () => ({
      ...settings,
      variant: StringVariants.date,
      placeholder: localPlaceholder,
    }),
    [localPlaceholder]
  )
  const transformedValue = (value: string) => {
    console.log(value)
    try {
          if (value) {
            const transfValue = value
              .split('.')
              .map((datePart: string) =>
                datePart
                  .split('')
                  .filter((symbol) => {
                    const m = symbol.match(/\d/)
                    console.log(m)
                    return m
                  })
                  .join('')
              )
              .reverse()
              .join('-')
              console.log(transfValue)
            return transfValue
          }
        } catch (error) {
          console.log(error)
        }
  }

  const disabled = useMemo(() => status === IInputStatus.disabled, [status])

  const handleLocalChange = (newValue: string) => {
    try {
      setChangeStatusHandler()
      // setLocalStatus(IInputStatus.change)
      // Количество числовых символов в старом значении даты
      const oldDateLength = value && value.match(ONLY_NUMBERS_REGEX)?.join('').length
      // Установка вместо даты маски
      //handleChange(name, DATE_MASK, settings.isValidate)

      // Получение чисовой последовательности
      const filteredValue = newValue.match(ONLY_NUMBERS_REGEX)?.join('')

      // Формирование массива даты
      const dateArr = filteredValue
        ?.split(GLUED_DATE_STRING_REGEX)
        .filter((elem) => elem)
        .slice(0, DATE_PARTS_COUNT)

      // Количество числовых символов в новом значении даты
      const newDateLength = dateArr?.join('').length

      // Установка флага сигнализирующего об удалении
      if (!oldDateLength && newDateLength) {
        setIsDelete(false)
      } else if (oldDateLength && !newDateLength) {
        setIsDelete(true)
      } else if (oldDateLength && newDateLength) {
        setIsDelete(oldDateLength > newDateLength)
      }

      // Сборка даты из массива
      const maskedDate = createMaskedDate(dateArr)

      checkChangeValue(name)
      // Изменение локального значения даты
      setLocalValue(maskedDate ?? DATE_MASK)
      //handleChange(name, maskedDate ?? DATE_MASK, settings.isValidate)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeWrapper = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const newValue = event.target.value
      // Сохранить позицию курсора при изменении
      if (event.target.selectionStart) {
        setCursorPosition(event.target.selectionStart)
      }
      // Запрет ввода всех символов, кроме числовых и символов маски
  
      if (!newValue.match(NUMBERS_AND_MASK_SYMBOLS_REGEX) && newValue !== '') {
        event.preventDefault()
      } else {
        handleLocalChange(newValue)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleKeydown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    try {
      if (event.key === 'Enter') {
        setFocused(false)
        const transfValue = transformedValue(localValue)
        handleChange(name, transfValue as string, true)
        if (progressTrigger) {
          progressTrigger()
        }
      } else if (event.key === 'Escape') {
        setFocused(false)
        setLocalValue(value)
        if (progressTrigger) {
          progressTrigger()
        }
      }
      // Обработка удаления символов даты
      if (inputRef.current) {
        if (inputRef.current.selectionEnd) {
          setCursorPosition(inputRef.current.selectionEnd)
        }
        let regexForRemoveValue
        let trueCursorPosition
        let newValue
        switch (event.key) {
          case 'Backspace':
            setKeyType(KeyTypes.backspace)
            // Получить положение курсора без учёта разделителей
            trueCursorPosition = getTrueCursorPosition(
              inputRef.current.selectionEnd ?? cursorPosition
            )
            // Заменить данные по шаблону
            event.preventDefault()
            regexForRemoveValue = new RegExp(
              `(\\d{0,${trueCursorPosition - 1}})(\\d)(\\d*)`,
              'g'
            )
            newValue = localValue
              .match(ONLY_NUMBERS_REGEX)
              ?.join('')
              .replace(regexForRemoveValue, '$1$3')
            handleLocalChange(newValue ?? localValue)
            //setCursorPosition(cursorPosition - 1)
            break
          case 'Delete':
            setKeyType(KeyTypes.delete)
            // Получить положение курсора без учёта разделителей
            trueCursorPosition = getTrueCursorPosition(
              inputRef.current.selectionEnd ?? cursorPosition
            )
            // Заменяем данные по шаблону
            event.preventDefault()
            regexForRemoveValue = new RegExp(
              `(\\d{0,${trueCursorPosition}})(\\d)(\\d*)`,
              'g'
            )
            newValue = localValue
              .match(ONLY_NUMBERS_REGEX)
              ?.join('')
              .replace(regexForRemoveValue, '$1$3')
            handleLocalChange(newValue ?? localValue)
            break
          default:
            setKeyType(KeyTypes.default)
            break
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    try {
      const data = event.clipboardData.getData('text/plain')
      event.preventDefault()
      if (data.match(NUMBERS_AND_MASK_SYMBOLS_REGEX)) {
        // Удаление нечисловых значений
        const filteredData = data.match(ONLY_NUMBERS_REGEX)?.join('')
        // Разделение строки по шаблону
        const dateArr = filteredData
          ?.split(GLUED_DATE_STRING_REGEX)
          .filter((elem) => elem)
        // Сборка даты из массива
        const maskedDate = createMaskedDate(dateArr?.slice(0, DATE_PARTS_COUNT))
  
        setLocalValue(maskedDate ?? DATE_MASK)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleFocus = () => {
    setFocused(true)
  }

  const handleBlur = () => {
    try {
      if (!localValue.match(ONLY_NUMBERS_REGEX)) {
        setLocalValue('')
      }
      setFocused(false)
      changeStatusHandler()
      let transfValue = !/[0-9]/.test(localValue as string) ? '' : transformedValue(localValue)
      console.log('handleBlur', localValue, transfValue)
      // if (!/[0-9]/.test(transfValue as string)) transfValue = ''
      handleChange(name, transfValue as string, true)
      if (progressTrigger) {
        progressTrigger()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange: handleChangeWrapper,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
  }
}
